export const SET_USER_ROLES = `SET_USER_ROLES`;
export const FETCH_EMAIL_GROUPS = 'FETCH_EMAIL_GROUPS';
export const FETCH_EMAIL_GROUPS_SUCCESS = 'FETCH_EMAIL_GROUPS_SUCCESS';
export const FETCH_EMAIL_GROUPS_FAILED = 'FETCH_EMAIL_GROUPS_FAILED';
export const FETCH_USER_EMAIL_GROUPS = 'FETCH_USER_EMAIL_GROUPS';
export const FETCH_USER_EMAIL_GROUPS_SUCCESS = 'FETCH_USER_EMAIL_GROUPS_SUCCESS';
export const FETCH_USER_EMAIL_GROUPS_FAILED = 'FETCH_USER_EMAIL_GROUPS_FAILED';
export const UPDATE_USER_EMAIL_GROUPS = 'UPDATE_USER_EMAIL_GROUPS';
export const UPDATE_USER_EMAIL_GROUPS_SUCCESS = 'UPDATE_USER_EMAIL_GROUPS_SUCCESS';
export const UPDATE_USER_EMAIL_GROUPS_FAILED = 'UPDATE_USER_EMAIL_GROUPS_FAILED';

export const FETCH_ADMIN_EMAILS = 'FETCH_ADMIN_EMAILS';
export const FETCH_ADMIN_EMAILS_SUCCESS = 'FETCH_ADMIN_EMAILS_SUCCESS';
export const FETCH_ADMIN_EMAILS_FAILED = 'FETCH_ADMIN_EMAILS_FAILED';

export const FETCH_USER_POSITIONS = 'FETCH_USER_POSITIONS';
export const FETCH_USER_POSITIONS_SUCCESS = 'FETCH_USER_POSITIONS_SUCCESS';
export const FETCH_USER_POSITIONS_FAILED = 'FETCH_USER_POSITIONS_FAILED';

export const setUserRoles = (payload: string[]) => ({
  type: SET_USER_ROLES,
  payload,
});

export const fetchEmailGroups = () => ({
  type: FETCH_EMAIL_GROUPS,
});

export const fetchEmailGroupsSuccess = (payload) => {
  return {
    type: FETCH_EMAIL_GROUPS_SUCCESS,
    payload,
  };
};

export const fetchEmailGroupsFailed = (payload) => ({
  type: FETCH_EMAIL_GROUPS_FAILED,
  payload,
});

export const fetchUserEmailGroups = (payload) => ({
  type: FETCH_USER_EMAIL_GROUPS,
  payload,
});

export const fetchUserEmailGroupsSuccess = (payload) => ({
  type: FETCH_USER_EMAIL_GROUPS_SUCCESS,
  payload,
});

export const fetchUserEmailGroupsFailed = (payload) => ({
  type: FETCH_USER_EMAIL_GROUPS_FAILED,
  payload,
});

export const updateUserEmailGroups = (payload) => ({
  type: UPDATE_USER_EMAIL_GROUPS,
  payload,
});

export const updateUserEmailGroupsSuccess = (payload) => ({
  type: UPDATE_USER_EMAIL_GROUPS_SUCCESS,
  payload,
});

export const updateUserEmailGroupsFailed = (payload) => ({
  type: UPDATE_USER_EMAIL_GROUPS_FAILED,
  payload,
});
export const fetchTabVisibility = (payload) => ({
  type: FETCH_TAB_VISIBILITY,
  payload,
});

export const fetchTabVisibilitySuccess = (payload) => ({
  type: FETCH_TAB_VISIBILITY_SUCCESS,
  payload,
});

export const fetchTabVisibilityFailed = (error) => ({
  type: FETCH_TAB_VISIBILITY_FAILED,
  error,
});

export const fetchAdminEmails = () => ({
  type: FETCH_ADMIN_EMAILS,
});

export const fetchAdminEmailsSuccess = (payload) => ({
  type: FETCH_ADMIN_EMAILS_SUCCESS,
  payload,
});

export const fetchAdminEmailsFailed = (error) => ({
  type: FETCH_ADMIN_EMAILS_FAILED,
  error,
});

export const fetchUserPositions = (payload: any) => ({
  type: FETCH_USER_POSITIONS,
  payload,
});

export const fetchUserPositionsSuccess = (payload) => ({
  type: FETCH_USER_POSITIONS_SUCCESS,
  payload,
});

export const fetchUserPositionsFailed = (error) => ({
  type: FETCH_USER_POSITIONS_FAILED,
  error,
});

export const FETCH_TAB_VISIBILITY = 'FETCH_TAB_VISIBILITY';
export const FETCH_TAB_VISIBILITY_SUCCESS = 'FETCH_TAB_VISIBILITY_SUCCESS';
export const FETCH_TAB_VISIBILITY_FAILED = 'FETCH_TAB_VISIBILITY_FAILED';
